import React from 'react'
import ReactDOM from 'react-dom/client'
// Base styles first: component CSS (imported by App below) must come after them in the cascade.
import './styles/main.css'
import '@fontsource-variable/space-grotesk'
import '@fontsource-variable/inter'
import '@fontsource/instrument-serif'
import '@fontsource/instrument-serif/400-italic.css'
import App from './App.tsx'
import { initIfConsented } from './lib/analytics'

initIfConsented()

/*
 * Render once the fonts are in, so the headline never re-wraps when they arrive
 * (that re-wrap was a 0.16 layout shift) and the serif titles never reflow. The cap keeps a
 * slow or failed font from ever blocking the page: after 1.5s it renders with the system fallback.
 */
const fontsReady = document.fonts
  ? Promise.race([
      Promise.all([
        document.fonts.load('500 1em "Space Grotesk Variable"'),
        document.fonts.load('400 1em "Inter Variable"'),
        document.fonts.load('400 1em "Instrument Serif"'),
        document.fonts.load('italic 400 1em "Instrument Serif"'),
      ]),
      new Promise((resolve) => window.setTimeout(resolve, 1500)),
    ]).catch(() => undefined)
  : Promise.resolve();

fontsReady.then(() => {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
});
